export default __webpack_public_path__ + "images/b9ed40e647cf2b5c1f610c1822aba92d-info-blue.svg";